import axios from 'axios';
export default (id, payload) => {
  const promise = new Promise((resolve, reject) => {
    const payloadTransform = payload;
    axios
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${id}`, payloadTransform)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
